module.exports = __webpack_public_path__ + "img/crash.37c54945.png";